import { PaymentMethodWithCashlessAndBonusLabelTranslationKeys } from "#i18n/translations/pt-BR/components/payment-method-with-cashless-and-bonus";

export const PAYMENT_METHOD_WITH_CASHLESS_AND_BONUS_LABEL_FR_FR: PaymentMethodWithCashlessAndBonusLabelTranslationKeys = {
	ZigPosCredit: "ZigPos Crédit",
	ZigPosCreditInInstallments: "ZigPos Crédit en Versements",
	ZigPosDebit: "ZigPos Débit",
	CreditCard: "Carte de Crédit",
	DebitCard: "Carte de Débit",
	Cash: "Espèces",
	App: "Application",
	Voucher: "Bon",
	Anticipated: "Anticipé",
	Pix: "Pix",
	Cashless: "Cashless",
	IntegratedFoodVoucher: "Ticket Restaurant",
	MBWay: "MBWay",
	Bonus: "Bonus",
	MinimumConsumption: "Consommation minimale",
	Ifood: "Ifood",
};
